import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './components/Cart/CartContext';

import AddProductAdmin from './pages/adminArea/AddProductAdmin.jsx';
import Home from './pages/Home.jsx'
import Shop from './pages/Shop.jsx';
import HowItWorks from './pages/HowItWorks.jsx';
import ProductDetail from './components/Product/ProductDetail.jsx';
import Customize from './pages/Customize.jsx';
import Checkout from "./pages/Checkout";
import ThankYou from './pages/ThankYou.jsx';

const root = createRoot(document.querySelector('#root'))

root.render(
  <BrowserRouter>
    <CartProvider>
      <Routes>
        <Route path="*" element={<Home />} />
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/how-it-works" element={<HowItWorks/>} />
        <Route path="/admin-inventory" element={<AddProductAdmin />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/customize" element={<Customize />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/thankyou" element={<ThankYou />} />
      </Routes>
    </CartProvider>
  </BrowserRouter>
)